import { lazy, Suspense } from "react";

/**
 * MarkdownMessageLazy — Rev 26.3 bundle-cost guard.
 *
 * react-markdown + remark-gfm ship ~50 KB gz combined. The original
 * Loop A wired MarkdownMessage as a plain import, which pulled the
 * deps into the home-page entry chunk because CopilotComposer mounts
 * on /. Per the runbook's bundle threshold (+50 KB gz max), the entry
 * chunk regressed right at the line. This wrapper React.lazy()s the
 * underlying component so only the first chat surface that actually
 * renders an assistant turn pays the cost.
 *
 * The Suspense fallback renders the message content as plain text
 * with whitespace-pre-wrap so the visitor sees the answer immediately
 * (looks like the pre-26.3 render) while the Markdown renderer loads
 * in the background. Subsequent assistant turns within the session
 * pay zero — the chunk is cached.
 */

const InnerMarkdown = lazy(() =>
  import("./MarkdownMessage").then((m) => ({ default: m.MarkdownMessage })),
);

type Props = {
  content: string;
  className?: string;
};

export function MarkdownMessage({ content, className }: Props) {
  return (
    <Suspense
      fallback={
        <div
          className={`whitespace-pre-wrap leading-relaxed ${className ?? ""}`}
          data-markdown-message-fallback
        >
          {content}
        </div>
      }
    >
      <InnerMarkdown content={content} className={className} />
    </Suspense>
  );
}

export default MarkdownMessage;
